import _ from 'underscore';
import React from 'react';
import { Activity } from '@bingads-webui-react/hoc-with-signal';
import { getNeedConfirming } from '@bingads-webui-campaign-react/campaign-settings-utils';
import { AdFormat } from '@bingads-webui-campaign-react/display-plus-native-ads';

import { useVideoAdsRepository, VideoAds } from './video-ads';
import { useAdGroupRepository, AdGroupStepShell } from './adgroup';
import { useCampaignRepository, useCampaignEditRepository, CampaignStepShell } from './campaign';
import { useDisplayAdsRepository, DisplayAds } from './display-ads';
import { useNativeAdRepository, SingleNativeAdStepShell, NativeAdsContainer, MultiAdsStepShell, useMultipleNativeAdsRepository, useNativeAdsManagerRepository } from './native-ads';
import { useSummaryRepository, SummaryStepShell } from './summary';
import { SingleMultiAdFormatStepShell, MultiAdFormatStepShell, MultiAdFormatAdsContainer, useMultiAdFormatAdsManagerRepository, useMultiAdFormatRepository, useSingleMultiAdFormatRepository } from './multi-ad-format';
import { STEP_PATHS, WIZARD_TYPES } from '../step-constants';

const editWizardTypeList = [
  WIZARD_TYPES.AUDIENCE_CAMPAIGN_EDIT,
  WIZARD_TYPES.AUDIENCE_AD_GROUP_EDIT,
  WIZARD_TYPES.AUDIENCE_CAMPAIGN_CTV_EDIT,
  WIZARD_TYPES.AUDIENCE_AD_GROUP_CTV_EDIT,
  WIZARD_TYPES.AUDIENCE_CAMPAIGN_DEAL_EDIT,
  WIZARD_TYPES.AUDIENCE_AD_GROUP_DEAL_EDIT,
];

export const getStepConfig = (permissions, wizardType, adsType = '', loadClipchampPlayer = null) => StepConfig.map((step) => {
  if (_.get(permissions, ['dynamic', 'ConversionAssociationWarning']) && editWizardTypeList.includes(wizardType) && step.id === STEP_PATHS.CAMPAIGN_EDIT) {
    const mapStep = {
      ...step,
      machineOptions: {
        guards: {
          needsConfirming: context => getNeedConfirming(permissions, context),
        },
      },

    };
    return mapStep;
  } else if (step.id === STEP_PATHS.VIDEO_AD) {
    const updatedVideoStep = {
      ...step,
      view: props => <Activity name="VideoAdsSettings"> <VideoAds {...props} loadClipchampPlayer={loadClipchampPlayer} /> </Activity>,
    };
    return updatedVideoStep;
  } else if (step.id === STEP_PATHS.NATIVE_AD) {
    if (adsType === AdFormat.Display) {
      const updatedStep = {
        ...step,
        view: props => <DisplayAds {...props} />,
        repository: useDisplayAdsRepository,
      };
      return updatedStep;
    }

    return {
      ...step,
    };
  }
  return step;
});

export const StepConfig = [{
  id: STEP_PATHS.VIDEO_AD,
  view: props => <Activity name="VideoAdsSettings"> <VideoAds {...props} /> </Activity>,
  repository: useVideoAdsRepository,
},
{
  id: STEP_PATHS.DISPLAY_AD,
  view: props => <DisplayAds {...props} />,
  repository: useDisplayAdsRepository,
},
{
  id: STEP_PATHS.NATIVE_AD,
  view: props => <Activity name="NativeAdStepSettings"> <SingleNativeAdStepShell {...props} /> </Activity>,
  repository: useNativeAdRepository,
},
{
  id: STEP_PATHS.MULTI_NATIVE_AD,
  view: props => <Activity name="MultiNativeAdStepSettings"> <MultiAdsStepShell {...props} /> </Activity>,
  repository: useMultipleNativeAdsRepository,
},
{
  id: STEP_PATHS.MULTI_AD_MANAGER,
  view: props => <Activity name="MultiAdsManager"> <NativeAdsContainer {...props} /> </Activity>,
  repository: useNativeAdsManagerRepository,
},
{
  id: STEP_PATHS.AD_GROUP,
  view: props => <Activity name="AdGroupStepSettings"> <AdGroupStepShell {...props} /> </Activity>,
  repository: useAdGroupRepository,
},
{
  id: STEP_PATHS.CAMPAIGN_CREATION,
  view: props => <Activity name="BudgetAndBidSettings"> <CampaignStepShell {...props} /> </Activity>,
  repository: useCampaignRepository,
},
{
  id: STEP_PATHS.CAMPAIGN_EDIT,
  view: props => <Activity name="CampaignEdit"> <CampaignStepShell {...props} /> </Activity>,
  repository: useCampaignEditRepository,
},
{
  id: STEP_PATHS.SUMMARY,
  view: props => <Activity name="SummaryStepSettings"> <SummaryStepShell {...props} /> </Activity>,
  repository: useSummaryRepository,
}];

export const getStepConfigMultiAdFormat = (permissions, wizardType, adsType = '', loadClipchampPlayer = null) => StepConfigMultiAdFormat.map((step) => {
  if (_.get(permissions, ['dynamic', 'ConversionAssociationWarning']) && editWizardTypeList.includes(wizardType) && step.id === STEP_PATHS.CAMPAIGN_EDIT
  ) {
    const mapStep = {
      ...step,
      machineOptions: {
        guards: {
          needsConfirming: context => getNeedConfirming(permissions, context),
        },
      },

    };
    return mapStep;
  } else if (step.id === STEP_PATHS.NATIVE_AD) {
    if (adsType === AdFormat.Display) {
      const updatedStep = {
        ...step,
        view: props => <Activity name="NativeAdStepSettings"> <SingleMultiAdFormatStepShell {...props} adsType={adsType} /> </Activity>,
      };
      return updatedStep;
    }

    return {
      ...step,
      view: props => <Activity name="NativeAdStepSettings"> <SingleMultiAdFormatStepShell {...props} loadClipchampPlayer={loadClipchampPlayer} /> </Activity>,
    };
  } else if (step.id === STEP_PATHS.VIDEO_AD) {
    const updatedVideoStep = {
      ...step,
      view: props => <Activity name="VideoAdsSettings"> <VideoAds {...props} loadClipchampPlayer={loadClipchampPlayer} /> </Activity>,
    };
    return updatedVideoStep;
  } else if (step.id === STEP_PATHS.MULTI_NATIVE_AD) {
    const updatedMultiAdFormatStep = {
      ...step,
      view: props => <Activity name="MultiNativeAdStepSettings"> <MultiAdFormatStepShell {...props} loadClipchampPlayer={loadClipchampPlayer} /> </Activity>,
    };
    return updatedMultiAdFormatStep;
  }

  return step;
});

export const StepConfigMultiAdFormat = [{
  id: STEP_PATHS.NATIVE_AD,
  view: props => <Activity name="NativeAdStepSettings"> <SingleMultiAdFormatStepShell {...props} /> </Activity>,
  repository: useSingleMultiAdFormatRepository,
},
{
  id: STEP_PATHS.MULTI_NATIVE_AD,
  view: props => <Activity name="MultiNativeAdStepSettings"> <MultiAdFormatStepShell {...props} /> </Activity>,
  repository: useMultiAdFormatRepository,
},
{
  id: STEP_PATHS.VIDEO_AD,
  view: props => <Activity name="VideoAdsSettings"> <VideoAds {...props} /> </Activity>,
  repository: useVideoAdsRepository,
},
{
  id: STEP_PATHS.MULTI_AD_MANAGER,
  view: props => <Activity name="MultiAdsManager"> <MultiAdFormatAdsContainer {...props} /> </Activity>,
  repository: useMultiAdFormatAdsManagerRepository,
},
{
  id: STEP_PATHS.AD_GROUP,
  view: props => <Activity name="AdGroupStepSettings"> <AdGroupStepShell {...props} /> </Activity>,
  repository: useAdGroupRepository,
},
{
  id: STEP_PATHS.CAMPAIGN_CREATION,
  view: props => <Activity name="BudgetAndBidSettings"> <CampaignStepShell {...props} /> </Activity>,
  repository: useCampaignRepository,
},
{
  id: STEP_PATHS.CAMPAIGN_EDIT,
  view: props => <Activity name="CampaignEdit"> <CampaignStepShell {...props} /> </Activity>,
  repository: useCampaignEditRepository,
},
{
  id: STEP_PATHS.SUMMARY,
  view: props => <Activity name="SummaryStepSettings"> <SummaryStepShell {...props} /> </Activity>,
  repository: useSummaryRepository,
}];
